module.exports = __webpack_public_path__ + "static/skateboard-eae29dcb84bec8ce32c06aaa8727087f.svg";